import React from "react";
import { AlertCard } from "@truevault/aquilo";

export const SensitiveInfoCallout = ({ sensitivePICs }: { sensitivePICs?: string[] }) => {
  const hasSensitivePICs = sensitivePICs && sensitivePICs.length > 0;

  return (
    <div className="tw-boundary">
      <AlertCard variant="warning" containerClasses="mb-0">
        <div className="text-t3">
          <strong>
            Don't disclose sensitive information.
            {hasSensitivePICs ? ` Here's what you collect: ${sensitivePICs.join(", ")}` : ""}
          </strong>
        </div>
      </AlertCard>
    </div>
  );
};
